var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vs-table__container" },
    [
      _c(
        "vs-layout",
        {
          staticClass: "vs-table__title-container",
          attrs: {
            "no-gutter": "no-gutter",
            "vert-align-center-xs": "vert-align-center-xs",
            "wrap-xs": "wrap-xs",
            "no-wrap-lg": "no-wrap-lg",
            "space-between-lg": "space-between-lg"
          }
        },
        [
          _vm.title
            ? _c(
                "vs-layout",
                {
                  attrs: {
                    "no-gutter": "no-gutter",
                    "no-shrink-xs": "no-shrink-xs",
                    lg: "3",
                    xxl: "2"
                  }
                },
                [
                  _c("h5", { staticClass: "vs-table__title" }, [
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.title) +
                          " " +
                          _vm._s(_vm.count >= 0 ? "(" + _vm.count + ")" : "")
                      )
                    ]),
                    _vm.titleHasHelpIconMobile
                      ? _c("span", {
                          ref: "tooltip",
                          staticClass:
                            "mdi mdi-help-circle vs-table__title-help--mobile-hide",
                          on: {
                            click: function($event) {
                              return _vm.$emit("help")
                            }
                          }
                        })
                      : _vm._e(),
                    _vm.titleHasHelpIcon
                      ? _c("span", {
                          staticClass:
                            "mdi mdi-help-circle vs-table__title-help",
                          on: {
                            click: function($event) {
                              return _vm.$emit("help")
                            }
                          }
                        })
                      : _vm._e()
                  ])
                ]
              )
            : _vm._e(),
          _vm.safeNav(_vm.tabs, "length")
            ? _c(
                "vs-layout",
                { attrs: { "no-gutter": "no-gutter", "grow-lg": "grow-lg" } },
                [
                  _c("vs-tabs", {
                    attrs: {
                      tabs: _vm.tabs,
                      "active-tab": _vm.activeTab,
                      disabled: _vm.processing
                    },
                    on: { "change-tab": _vm.changeTab }
                  })
                ],
                1
              )
            : _vm.message1 && _vm.message2
            ? _c(
                "vs-layout",
                {
                  staticClass: "vs-table__messages",
                  attrs: {
                    "no-gutter": "no-gutter",
                    "grow-lg": "grow-lg",
                    "hide-lg-down": "hide-lg-down"
                  }
                },
                [
                  _c("h6", [_c("strong", [_vm._v(_vm._s(_vm.message1))])]),
                  _c("h6", [_vm._v(_vm._s(_vm.message2))])
                ]
              )
            : _vm._e(),
          !_vm.buttonHidden
            ? _c(
                "vs-layout",
                {
                  staticClass: "vs-table__button",
                  attrs: {
                    "no-gutter": "no-gutter",
                    "no-shrink-xs": "no-shrink-xs",
                    "horz-align-right-xs": "horz-align-right-xs",
                    lg: "3",
                    xxl: "2"
                  }
                },
                [
                  _c("vs-button", {
                    attrs: {
                      disabled: _vm.buttonDisabled,
                      icon: _vm.buttonIcon,
                      text: _vm.buttonText,
                      processing: _vm.processing,
                      "not-visible": _vm.buttonNotVisible,
                      "single-line-button": _vm.buttonSingleLine
                    },
                    on: {
                      click: function($event) {
                        return _vm.$emit("container-button-click")
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("vs-container-controls", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.hideDate || !_vm.hideSearch,
            expression: "!hideDate || !hideSearch"
          }
        ],
        ref: "controlsContainer",
        staticClass: "sticky top-0 z-10",
        attrs: {
          "search-text": _vm.searchText,
          "search-placeholder": _vm.searchPlaceholder,
          "hide-search": _vm.hideSearch,
          "hide-date": _vm.hideDate,
          timezone: _vm.timezone
        },
        on: {
          search: _vm.handleSearch,
          "container-date-changed": _vm.handleDateChanged
        }
      }),
      _vm._t("default"),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.processing && !_vm.hideLazyLoader,
              expression: "processing && !hideLazyLoader"
            }
          ],
          staticClass: "lazy-progress"
        },
        [_c("vs-logo-loader")],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }